<script>
    import {
        SvelteTable,
        CollapsibleTableIcons,
        LoadingModal,
        TableElementEditableStatus,
        TableElementEditableReceiveDate,
        TableElementEditableAmount,
        RecordPaymentModal,
        CardLayout,
        NotificationModal,
        TableElementEditableTransactionDate,
    } from "../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import {
        addIcon,
        InsuranceTypesBypassDisabledComms,
    } from "../../../Utils/utilConstants.svelte";
    import {
        DirectDoctorStatus,
        DirectEncounterStatus,
        PatientPayInsuranceTypes,
    } from "../../../Utils/utilEnums.svelte";

    import {
        formatPortalUrls,
        getAmountInCurrency,
        getEstimatePaidBy,
        getEstimatePaidFor,
        getEstimatePaidMethod,
        getFormatDateAndTime,
        getText,
        goToDownloadPage,
        goToURL,
        isObjectEmpty,
        openPortalPage,
        runWithCommunicationsCheck,
        showError,
        showException,
        showPopupNotification,
        splitPaymentAmount,
    } from "../../../Utils/utilFunctions.svelte";

    import { syncInvoiceCalculationAmountBasedOnPayments } from "../helpers/encounterHelper.svelte";

    export let paymentsData = [];
    export let isUserDoctor = false;
    export let isUserEnableSeePaymentReceive = false;
    export let quotesData = [];
    export let invoicesData = [];
    export let latestQuoteData = {};
    export let latestInvoiceData = {};
    export let reloadBillingDetails = () => {};
    export let regenerateQuoteOrInvoice = () => {};
    export let patientEncounterDetails;

    let isDownloadingPayment = false,
        isRegeneratingPayment = false,
        isSendingReceiptToPatient = false,
        isReceiptSendToPatient = false,
        _initPaymentsFromEncounterView = () => {},
        isRecordPaymentModalOpen = false;

    let isSendingPaymentRefundCollectPatientBankDetails = false,
        isPaymentRefundCollectPatientBankDetailsSendToPatient = false;

    let paymentDetails = {};

    $: showRecordPaymentBtn = quotesData.length || invoicesData.length;

    $: if (showRecordPaymentBtn) btnOptions[0].isHidden = false;
    else btnOptions[0].isHidden = true;

    $: if (
        isUserEnableSeePaymentReceive &&
        !columnsForAdmin.some((col) => col.key == "paymentStatus")
    )
        columnsForAdmin.splice(12, 0, {
            key: "paymentStatus",
            title: "Status",
            headerClass: "text-left px-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            renderComponent: {
                component: TableElementEditableStatus,
                props: {
                    type: "paymentFromView",
                    onFinish: async () => {
                        await reloadBillingDetails();

                        await syncInvoiceCalculationAmountBasedOnPayments(
                            latestQuoteData,
                            latestInvoiceData,
                            quotesData,
                            regenerateQuoteOrInvoice,
                        );
                    },
                },
            },
        });

    const columnsForAdmin = [
        {
            key: "id",
            title: "Receipt ID",
            headerClass: "text-left px-3 cursor-default w-[10%] rounded-tl-xl",
            class: "text-left px-3 font-bold cursor-default w-[10%]",
            renderValue: (v) => _getReceiptId(v.receiptId),
        },
        {
            key: "paymentId",
            title: "Payment ID",
            headerClass: "text-left px-3 cursor-default w-[10%] rounded-tl-xl",
            class: "text-left px-3 font-bold cursor-default w-[10%]",
            renderValue: (v) => getText(v.id),
        },
        {
            key: "paidFor",
            title: "Paid for",
            headerClass: "text-left pl-3 cursor-default w-[10%] rounded-tl-xl",
            class: "text-left px-3 cursor-default w-[10%]",
            renderValue: (v) => getEstimatePaidFor(v.relTo),
        },
        {
            key: "paidForId",
            title: "Paid for ID",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            renderValue: (v) => _getPaidForId(v),
        },
        {
            key: "dateConfirmed",
            title: "Date Created",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            renderValue: (v) => _getFormatDate(v.createdDate),
        },
        {
            key: "transactionDate",
            title: "Date Received",
            headerClass: "text-left px-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderComponent: {
                component: TableElementEditableTransactionDate,
                props: {
                    type: "PatientEncounterPaymentTable",
                    onFinish: () => reloadBillingDetails(),
                },
            },
        },
        {
            key: "receiveDate",
            title: "Date Reconciled",
            headerClass: "text-left px-3 cursor-default",
            class: "text-left px-3 cursor-default",
            renderComponent: {
                component: TableElementEditableReceiveDate,
                props: {
                    type: "PatientEncounterPaymentTable",
                    onFinish: () => reloadBillingDetails(),
                },
            },
        },
        {
            key: "paidBy",
            title: "Paid by",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            renderValue: (v) => getEstimatePaidBy(v.paidBy),
        },
        {
            key: "paymentMethod",
            title: "Payment Method",
            headerClass: "text-left pl-3 cursor-default w-[15%]",
            class: "text-left px-3 cursor-default w-[15%]",
            value: (v) => getEstimatePaidMethod(v.paymentMethod),
        },
        {
            key: "amount",
            title: "Subtotal Amount",
            headerClass: "text-left px-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            renderComponent: {
                component: TableElementEditableAmount,
                props: {
                    type: "PatientEncounterPaymentTable",
                    onFinish: async () => {
                        await reloadBillingDetails();

                        await syncInvoiceCalculationAmountBasedOnPayments(
                            latestQuoteData,
                            latestInvoiceData,
                            quotesData,
                            regenerateQuoteOrInvoice,
                        );
                    },
                },
            },
        },
        {
            key: "processingFee",
            title: "Processing Fee",
            headerClass: "text-left px-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            value: (v) => getAmountInCurrency(splitPaymentAmount(v).processing),
            headerConfig: {
                showTooltip: true,
                tooltipContent: "Internal and credit cards processing fees",
            },
        },
        {
            key: "gst",
            title: "GST",
            headerClass: "text-left px-3 cursor-default",
            class: "text-left px-3",
            renderValue: (v) =>
                getAmountInCurrency(
                    v.includesGST ? splitPaymentAmount(v).gst : 0,
                ),
        },
        {
            key: "total",
            title: "Total Amount",
            headerClass: "text-left px-3 cursor-default",
            class: "text-left px-3",
            renderValue: (v) =>
                getAmountInCurrency(splitPaymentAmount(v).total),
        },
        {
            key: "transactionId",
            title: "Transaction ID",
            headerClass: "text-left px-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            value: (v) => getText(v.transactionId),
        },
        {
            key: "approvalNumber",
            title: "Reference",
            headerClass: "text-left px-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            value: (v) => getText(v.approvalNumber),
        },
        {
            key: "buttons",
            title: "",
            headerClass: "text-left pl-3 cursor-default rounded-tr-xl w-[5%]",
            class: "text-left px-3 cursor-default w-[5%]",
            renderComponent: {
                component: CollapsibleTableIcons,
                props: {
                    icons: [
                        "downloadLinkIcon",
                        "downloadIcon",
                        "reGenerateIcon",
                        "sendToPatientIcon",
                        "editPaymentIcon",
                        "sendRefundConfirmationIcon",
                        "goToPortalPageIcon",
                    ],
                    tableType: "Receipt",
                    showPatientInDownload: PatientPayInsuranceTypes.includes(
                        patientEncounterDetails?.patient?.insuranceType,
                    ),
                },
            },
        },
    ];

    const columnsForDoctor = [
        {
            key: "id",
            title: "Receipt ID",
            headerClass: "text-left px-3 cursor-default w-[10%] rounded-tl-xl",
            class: "text-left px-3 font-bold cursor-default w-[10%]",
            renderValue: (v) => _getReceiptId(v.receiptId),
        },
        {
            key: "paymentId",
            title: "Payment ID",
            headerClass: "text-left px-3 cursor-default w-[10%] rounded-tl-xl",
            class: "text-left px-3 font-bold cursor-default w-[10%]",
            renderValue: (v) => getText(v.id),
        },
        {
            key: "paidFor",
            title: "Paid for",
            headerClass: "text-left pl-3 cursor-default w-[10%] rounded-tl-xl",
            class: "text-left px-3 cursor-default w-[10%]",
            renderValue: (v) => getEstimatePaidFor(v.relTo),
        },
        {
            key: "paidForId",
            title: "Paid for ID",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            renderValue: (v) => getText(v.relId),
        },
        {
            key: "dateConfirmed",
            title: "Date Created",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            renderValue: (v) => _getFormatDate(v.createdDate),
        },
        {
            key: "paidBy",
            title: "Paid by",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            renderValue: (v) => getEstimatePaidBy(v.paidBy),
        },
        {
            key: "paymentMethod",
            title: "Payment Method",
            headerClass: "text-left pl-3 cursor-default w-[15%]",
            class: "text-left px-3 cursor-default w-[15%]",
            value: (v) => getEstimatePaidMethod(v.paymentMethod),
        },
        {
            key: "amount",
            title: "Amount",
            headerClass: "text-left px-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            value: (v) => _getAmountForDoctor(v.amount, v.processingFee),
        },
        {
            key: "transactionId",
            title: "Transaction ID",
            headerClass: "text-left px-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            value: (v) => getText(v.transactionId),
        },
        {
            key: "approvalNumber",
            title: "Reference",
            headerClass: "text-left px-3 cursor-default w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            value: (v) => getText(v.approvalNumber),
        },
        {
            key: "buttons",
            title: "",
            headerClass: "text-left pl-3 cursor-default rounded-tr-xl w-[5%]",
            class: "text-left px-3 cursor-default w-[5%]",
            renderComponent: {
                component: CollapsibleTableIcons,
                props: {
                    icons: [
                        "downloadLinkIcon",
                        "downloadIcon",
                        "reGenerateIcon",
                        "sendToPatientIcon",
                        "editPaymentIcon",
                        "sendRefundConfirmationIcon",
                        "goToPortalPageIcon",
                    ],
                    tableType: "Receipt",
                    showPatientInDownload: PatientPayInsuranceTypes.includes(
                        patientEncounterDetails?.patient?.insuranceType,
                    ),
                },
            },
        },
    ];

    const columns = isUserDoctor ? columnsForDoctor : columnsForAdmin;

    const btnOptions = [
        {
            iconName: "addIcon",
            iFont: addIcon,
            iconFunction: () => openRecordPaymentModal(),
            hasTooltip: true,
            tooltip: "Record payment",
            btnText: "Add",
        },
    ];

    const handleClickCell = (
        { target: { className, classList } },
        rowData,
        key,
    ) => {
        if (key == "buttons") {
            if (classList.contains("downloadIcon"))
                downloadPayment(rowData.receiptId);
            else if (classList.contains("reGenerateIcon"))
                regeneratePayment(rowData);
            else if (className.includes("goToPortalPageIcon"))
                openPortalPage(rowData, patientEncounterDetails.patient);
            else if (classList.contains("downloadLinkIcon"))
                goToPayments(rowData.receiptId);
            else if (classList.contains("sendToPatientIcon")) {
                if (
                    patientEncounterDetails?.doctor?.status !==
                        DirectDoctorStatus.Active &&
                    patientEncounterDetails?.doctor?.status !==
                        DirectDoctorStatus.Demo
                )
                    return showPopupNotification(
                        "Account not active",
                        "The encounter doctor is not active. Please enable it to send this receipt.",
                    );
                if (
                    patientEncounterDetails?.status ===
                    DirectEncounterStatus.Archived
                )
                    return showPopupNotification(
                        "The encounter is archived",
                        "The encounter is archived. Please un-archive it to send this receipt.",
                    );
                
                if (patientEncounterDetails?.patient?.deceased)
                    return showPopupNotification(
                        "Patient Deceased",
                        "Unable to send receipt, patient deceased.",
                    );

                if (patientEncounterDetails.disableNotifications &&
                    InsuranceTypesBypassDisabledComms.includes(patientEncounterDetails.patient.insuranceType)
                ) {
                    //if insurance type allows to bypass disabled comms, send receipt without showing comms disabled popup
                    sendReceiptToPatient(rowData.receiptId);
                }
                else {
                    runWithCommunicationsCheck(patientEncounterDetails, () => sendReceiptToPatient(rowData.receiptId));
                }
                    
            } else if (classList.contains("sendRefundConfirmationIcon"))
                sendRefundConfirmationToPatient(rowData);
            else if (classList.contains("editPaymentIcon"))
                openRecordPaymentModal(rowData);
        } else if (className.includes("receiptId"))
            goToURL(
                `/Receipts/page=0&size=25&doctor=${rowData.doctorId}&search=${rowData.receiptId}`,
            );
    };

    const handleClickCol = ({ target: { className } }, colData, key) => {};

    const downloadPayment = (id, isRegenerate) => {
        goToDownloadPage(2, id, isRegenerate);
    };

    const regeneratePayment = async (data) => {
        const { receiptId, doctorId, patientId, patientEncounterId } = data;

        const regenerateObj = {
            type: 2,
            entityId: receiptId,
            doctorId: doctorId,
            patientId: patientId,
            patientEncounterId: patientEncounterId,
        };

        isRegeneratingPayment = true;

        await apiMethods.postMethod
            .regeneratePdfFile(regenerateObj)
            .then((res) => {
                if (res.id) downloadPayment(receiptId, true);
                else
                    showError(
                        "Unable to re-generate this payment PDF, please refresh the page and try again and contact support if the issue persists.",
                    );
            })
            .catch((err) =>
                showException(
                    "Unable to re-generate this payment PDF, please refresh the page and try again and contact support if the issue persists.",
                ),
            );

        isRegeneratingPayment = false;
    };

    const goToPayments = (id) => {
        // const url = `https://portal.tcihealth.com.au/?r=${id}`;
        const url = formatPortalUrls("r", id);
        window.open(url, "_blank");
    };

    export const sendReceiptToPatient = async (id) => {
        isSendingReceiptToPatient = true;

        await apiMethods.getMethod
            .getReceiptById(id)
            .then(async (res) => {
                if (!res || !res.id || res.error)
                    showError(
                        "Failed to load receipt details, please refresh the page and try again and contact support if the issue persists.",
                    );
                else
                    await apiMethods.postMethod
                        .sendReceiptToPatient(res)
                        .then((res) => {
                            if (res.id) {
                                isReceiptSendToPatient = true;
                                reloadBillingDetails(true);
                            } else
                                showError(
                                    "Failed to send receipt to patient, please refresh the page and try again and contact support if the issue persists.",
                                );
                        });
            })
            .catch((err) => showException(err));

        isSendingReceiptToPatient = false;
    };

    const sendRefundConfirmationToPatient = async (payment) => {
        isSendingPaymentRefundCollectPatientBankDetails = true;

        await apiMethods.postMethod
            .paymentRefundCollectPatientBankDetails(payment)
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to send confirmation details to patient, please refresh the page and try again and contact support if the issue persists.",
                    );
                else
                    isPaymentRefundCollectPatientBankDetailsSendToPatient = true;
            });

        isSendingPaymentRefundCollectPatientBankDetails = false;
    };

    const openRecordPaymentModal = async (paymentData = {}) => {
        isRecordPaymentModalOpen = true;

        if (isObjectEmpty(paymentData)) await _initPaymentsFromEncounterView();
        else paymentDetails = { ...paymentData, isEditPayment: true };
    };

    const closeRecordPaymentModal = async (needReload = false) => {
        isRecordPaymentModalOpen = false;

        paymentDetails = {};

        if (needReload) await reloadBillingDetails();
    };

    // HELPER FUNCTIONS
    const _getReceiptId = (receiptId) => {
        if (!receiptId) return "-";
        // return `<div class="receiptId cursor-pointer hover:underline">${receiptId}</div>`;
        return receiptId;
    };

    const _getPaidForId = (data) => {
        const { relTo } = data;

        if (relTo == 0) return data.estimateNumber;
        else if (relTo == 1) return data.invoiceNumber;
    };

    const _getFormatDate = (date) => {
        if (!date || date == "0001-01-01T00:00:00") return "-";

        return getFormatDateAndTime(date);
    };

    const _getAmountForDoctor = (amt, fee) => {
        return getAmountInCurrency(amt - fee);
    };
</script>

<CardLayout title="Payments" {btnOptions}>
    {#if paymentsData.length}
        <div
            class="w-full overflow-x-auto"
            id="EncounterPaymentsTableContainer"
        >
            <SvelteTable
                tableContainerId="EncounterPaymentsTableContainer"
                {columns}
                bind:rows={paymentsData}
                clickCellFunc={({ detail: { event, row, key } }) => {
                    handleClickCell(event, row, key);
                }}
                clickColFunc={({ detail: { event, row, key } }) => {
                    handleClickCol(event, row, key);
                }}
            />
        </div>
    {:else}
        <div class="grid flex-1 h-full card bg-white rounded-box">
            <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
                <p>No payments currently under this patient encounter</p>
            </div>
        </div>
    {/if}
</CardLayout>

{#if isDownloadingPayment}
    <LoadingModal titleText="Downloading Payment PDF..." />
{/if}

{#if isRegeneratingPayment}
    <LoadingModal titleText="Regenerating Payment PDF..." />
{/if}

{#if isSendingReceiptToPatient}
    <LoadingModal titleText="Sending Receipt to Patient..." />
{/if}

{#if isSendingPaymentRefundCollectPatientBankDetails}
    <LoadingModal titleText="Sending Confirmation to Patient..." />
{/if}

{#if isRecordPaymentModalOpen}
    <RecordPaymentModal
        route="patientEncounterBillingPayment"
        {isRecordPaymentModalOpen}
        {closeRecordPaymentModal}
        optionsArr={[...quotesData, ...invoicesData]}
        {paymentDetails}
        {paymentsData}
        isDoctorRegisteredForGST={patientEncounterDetails.doctor?.isRegisteredForGST}
        bind:_initPaymentsFromEncounterView
    />
{/if}

<NotificationModal
    isModalOpen={isReceiptSendToPatient ||
        isPaymentRefundCollectPatientBankDetailsSendToPatient}
    title="Done"
    showCancelBtn={false}
    submitText="Close"
    confirmAction={() => {
        isReceiptSendToPatient = false;
        isPaymentRefundCollectPatientBankDetailsSendToPatient = false;
    }}
    closeModalFunction={() => {
        isReceiptSendToPatient = false;
        isPaymentRefundCollectPatientBankDetailsSendToPatient = false;
    }}
    hideCrossButton
>
    <p class="leading-6 p-4">
        {isReceiptSendToPatient
            ? "Receipt sent to patient."
            : "Confirmation send to patient."}
    </p>
</NotificationModal>
